'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import MainLayout from '@/components/layout/MainLayout';
import { Shuffle, Loader2 } from 'lucide-react';

export default function RandomGamePage() {
  const router = useRouter();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      try {
        const res = await fetch('/api/games/random?scope=addicting', { cache: 'no-store' });
        if (!res.ok) throw new Error('No random game found');

        const payload = await res.json();
        const game = payload?.game;
        const target = game?.slug || game?.id;

        if (!cancelled && target) {
          router.push(`/game/${target}`);
          return;
        }
      } catch {
        // fallback below
      }

      if (!cancelled) {
        router.push('/');
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [router]);

  return (
    <MainLayout>
      <div className="flex flex-col items-center justify-center min-h-[60vh] space-y-6">
        <div className="relative">
          <div className="w-32 h-32 rounded-full bg-linear-to-br from-purple-500 to-pink-500 flex items-center justify-center animate-pulse">
            <Shuffle className="w-16 h-16 text-white animate-spin" style={{ animationDuration: '2s' }} />
          </div>
          <div className="absolute -inset-4 rounded-full border-4 border-purple-500/30 animate-ping" />
        </div>
        
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-bold text-foreground">Finding a random game...</h1>
          <p className="text-muted-foreground">Preparing something fun for you!</p>
        </div>

        <div className="flex items-center gap-2 text-muted-foreground">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    </MainLayout>
  );
}
